// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//     className: string
//     customersData: any
//     suppliersData: any
//     facilitiesData?: any
//     title?: string
// }

// const ChartsWidget12: React.FC<Props> = ({
//     className,
//     customersData,
//     suppliersData,
//     facilitiesData,
//     title = 'Supply chain Growth',
// }) => {
//     const chartRef = useRef<HTMLDivElement | null>(null)
//     const { mode } = useThemeMode()

//     const refreshChart = () => {
//         if (!chartRef.current) {
//             return
//         }

//         const height = parseInt(getCSS(chartRef.current, 'height'))
//         const chart = new ApexCharts(
//             chartRef.current,
//             getChartOptions(height, customersData, suppliersData, facilitiesData)
//         )
//         if (chart) {
//             chart.render()
//         }

//         return chart
//     }

//     useEffect(() => {
//         const chart = refreshChart()

//         return () => {
//             if (chart) {
//                 chart.destroy()
//             }
//         }
//     }, [chartRef, mode, customersData, suppliersData, facilitiesData])

//     return (
//         <div className={`card ${className}`}>
//             <div className='card-header border-0 pt-5'>
//                 <h3 className='card-title align-items-start flex-column'>
//                     <span className='card-label fw-bold fs-3 mb-1' style={{ color: '#000000' }}>
//                         {title}
//                     </span>
//                     <span className='text-dark fw-semibold fs-7'>
//                         Monthly trend of target achievement
//                     </span>
//                 </h3>
//             </div>

//             <div className='card-body'>
//                 <div
//                     ref={chartRef}
//                     style={{ height: '170px' }}
//                     className='card-rounded-bottom'
//                 ></div>
//             </div>
//         </div>
//     )
// }

// export { ChartsWidget12 }

// function getChartOptions(
//     height: number,
//     customersData: any,
//     suppliersData: any,
//     facilitiesData: any
// ): ApexOptions {
//     const labelColor = getCSSVariableValue('--bs-gray-900')
//     const borderColor = getCSSVariableValue('--bs-gray-200')
//     const strokeColor = getCSSVariableValue('--bs-gray-300')

//     const color1 = getCSSVariableValue('--bs-warning')
//     const color1Light = getCSSVariableValue('--bs-warning-light')

//     const color2 = getCSSVariableValue('--bs-success')
//     const color2Light = getCSSVariableValue('--bs-success-light')

//     const color3 = getCSSVariableValue('--bs-primary')
//     const color3Light = getCSSVariableValue('--bs-primary-light')

//     const categories = Object.keys(customersData || {})
//     const customersValues = Object.values(customersData || {})
//     const suppliersValues = Object.values(suppliersData || {})
//     const facilitiesValues = Object.values(facilitiesData || {})

//     return {
//         series: [
//             {
//                 name: 'Household Connected',
//                 data: customersValues as number[],
//             },
//             {
//                 name: 'Plastic Prevented',
//                 data: suppliersValues as number[],
//             },
//             // {
//             //     name: 'New Facilities',
//             //     data: facilitiesValues as number[],
//             // },
//         ],
//         chart: {
//             fontFamily: 'inherit',
//             type: 'area',
//             height: height,
//             toolbar: {
//                 show: false,
//             },
//             zoom: {
//                 enabled: false,
//             },
//             sparkline: {
//                 enabled: true,
//             },
//         },
//         plotOptions: {},
//         legend: {
//             show: false,
//         },
//         dataLabels: {
//             enabled: false,
//         },
//         fill: {
//             type: 'solid',
//             opacity: 1,
//         },
//         stroke: {
//             curve: 'smooth',
//             show: true,
//             width: 2,
//             colors: [color1, color2, color3],
//         },
//         xaxis: {
//             offsetX: 0,
//             offsetY: 0,
//             categories: categories,
//             axisBorder: {
//                 show: false,
//             },
//             axisTicks: {
//                 show: false,
//             },
//             labels: {
//                 show: false,
//                 style: {
//                     colors: labelColor,
//                     fontSize: '12px',
//                 },
//             },
//             crosshairs: {
//                 show: false,
//                 position: 'front',
//                 stroke: {
//                     color: strokeColor,
//                     width: 1,
//                     dashArray: 3,
//                 },
//             },
//             tooltip: {
//                 enabled: true,
//                 formatter: undefined,
//                 offsetY: 0,
//                 style: {
//                     fontSize: '12px',
//                 },
//             },
//         },
//         yaxis: {
//             labels: {
//                 show: false,
//                 style: {
//                     colors: labelColor,
//                     fontSize: '12px',
//                 },
//             },
//         },
//         states: {
//             normal: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             hover: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             active: {
//                 allowMultipleDataPointsSelection: false,
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//         },
//         // tooltip: {
//         //     style: {
//         //         fontSize: '12px',
//         //     },
//         //     y: {
//         //         formatter: function (val) {
//         //             return (val ?? 0).toString()
//         //         },
//         //     },
//         // },
//         tooltip: {
//     style: {
//         fontSize: '12px',
//     },
//     y: {
//         formatter: function (val, opts) {
//             // opts.seriesIndex: 0 = Household Connected, 1 = Plastic Prevented
//             if (opts.seriesIndex === 1) {
//                 return (val ?? 0).toString() + ' kg'
//             }
//             return (val ?? 0).toString()
//         },
//     },
// },
//         colors: [color1Light, color2Light, color3Light],
//         grid: {
//             borderColor: borderColor,
//             strokeDashArray: 4,
//             padding: {
//                 top: 0,
//                 bottom: 0,
//                 left: 0,
//                 right: 0,
//             },
//         },
//         markers: {
//             colors: [color1, color2, color3],
//             strokeColors: [color1, color2, color3],
//             strokeWidth: 3,
//         },
//     }
// }

import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
    className: string
    customersData: any
    suppliersData: any
    facilitiesData?: any
    title?: string
}

const ChartsWidget12: React.FC<Props> = ({
    className,
    customersData,
    suppliersData,
    facilitiesData,
    title = 'Supply chain Growth',
}) => {
    const chartRef = useRef<HTMLDivElement | null>(null)
    const { mode } = useThemeMode()

    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const height = parseInt(getCSS(chartRef.current, 'height'))
        const chart = new ApexCharts(
            chartRef.current,
            getChartOptions(height, customersData, suppliersData, facilitiesData)
        )
        if (chart) {
            chart.render()
        }

        return chart
    }

    useEffect(() => {
        const chart = refreshChart()

        return () => {
            if (chart) {
                chart.destroy()
            }
        }
    }, [chartRef, mode, customersData, suppliersData, facilitiesData])

    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1' style={{ color: '#000000' }}>
                        {title}
                    </span>
                    <span className='text-dark fw-semibold fs-7'>
                        Monthly trend of target achievement
                    </span>
                </h3>
            </div>

            <div className='card-body'>
                <div
                    ref={chartRef}
                    style={{ height: '170px' }}
                    className='card-rounded-bottom'
                ></div>
            </div>
        </div>
    )
}

export { ChartsWidget12 }

function getChartOptions(
    height: number,
    customersData: any,
    suppliersData: any,
    facilitiesData: any
): ApexOptions {
    const labelColor = getCSSVariableValue('--bs-gray-900')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const strokeColor = getCSSVariableValue('--bs-gray-300')

    // Household Connected
    const color1 = '#ed6e43'
    const color1Light = '#ed6e4340'

    // Plastic Prevented
    const color2 = '#ffe500'
    const color2Light = '#ffe50040'

    const color3 = getCSSVariableValue('--bs-primary')
    const color3Light = getCSSVariableValue('--bs-primary-light')

    const categories = Object.keys(customersData || {})
    const customersValues = Object.values(customersData || {})
    const suppliersValues = Object.values(suppliersData || {})
    const facilitiesValues = Object.values(facilitiesData || {})

    return {
        series: [
            {
                name: 'Household connected',
                data: customersValues as number[],
            },
            {
                name: 'Plastic prevented',
                data: suppliersValues as number[],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'area',
            height: height,
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
            sparkline: {
                enabled: true,
            },
        },
        plotOptions: {},
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 1,
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 2,
            colors: [color1, color2, color3],
        },
        xaxis: {
            offsetX: 0,
            offsetY: 0,
            categories: categories,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
            crosshairs: {
                show: false,
                position: 'front',
                stroke: {
                    color: strokeColor,
                    width: 1,
                    dashArray: 3,
                },
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                show: false,
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val, opts) {
                    if (opts.seriesIndex === 1) {
                        return (val ?? 0).toString() + ' kg'
                    }
                    return (val ?? 0).toString()
                },
            },
        },
        colors: [color1Light, color2Light, color3Light],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            padding: {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            },
        },
        markers: {
            colors: [color1, color2, color3],
            strokeColors: [color1, color2, color3],
            strokeWidth: 3,
        },
    }
}